(() => {
  'use strict';

  const SVG_NS = 'http://www.w3.org/2000/svg';
  const VERSION = 'Gen3';
  const PX_PER_MM = 96 / 25.4;
  const PRODUCTS = {
    'social-tap-sign': {
      name: 'Social Tap Sign',
      fileName: 'social-tap-sign',
      builder: 'social-tap-sign',
      base: 'Gen3-social-tap-sign-base.svg',
      guide: { x: 79.369331, y: 66.142676, width: 718.110649, height: 83.149334 },
      page: { width: 876.85173, height: 322.97507, widthMm: 232.00006, heightMm: 85.453712 },
      textHeightMm: 22,
      iconMaximumMm: 22,
      iconGapMm: 5
    },
    'name-sign': {
      name: 'Name Sign',
      fileName: 'name-sign',
      builder: 'name-sign',
      base: 'Gen3-name-sign-base.svg',
      page: { width: 1814.1732, height: 1058.2677, widthMm: 480, heightMm: 280 },
      nameGuide: { x: 75.590546, y: 84.094261, width: 1662.9921, height: 793.70081 },
      socialGuide: { x: 75.590546, y: 910.86157, width: 1662.9921, height: 83.149605 },
      textHeightMm: 22,
      iconMaximumMm: 22,
      iconGapMm: 5,
      borderLowerCornerStart: 863.62187,
      borderOuterBottom: 901.42159,
      collapseBottomInsetMm: 11
    },
    'mini-social-tap-sign': {
      name: 'Mini Social Tap Sign',
      fileName: 'mini-social-tap-sign',
      builder: 'mini-social',
      action: 'tap',
      base: 'Gen3-mini-social-tap-sign-base.svg',
      page: {
        x: 134.021732875674,
        y: 125.00012,
        width: 231.956495226541,
        height: 50.000352450005,
        widthMm: 231.956495226541,
        heightMm: 50.000352450005,
        mirrorTranslateX: 500
      },
      socialGuide: { x: 189.99943, y: 151.74701, width: 120.00002, height: 21.99992 },
      iconCenter: { x: 167.882275, y: 157.11913 },
      textHeightMm: 22,
      iconMaximumMm: 27.7641,
      allowNoIcon: false
    },
    'mini-social-scan-sign': {
      name: 'Mini Social Scan Sign',
      fileName: 'mini-social-scan-sign',
      builder: 'mini-social',
      action: 'scan',
      base: 'Gen3-mini-social-scan-sign-base.svg',
      page: {
        x: 134.021732875674,
        y: 125.00012,
        width: 231.956495226541,
        height: 50.000352450005,
        widthMm: 231.956495226541,
        heightMm: 50.000352450005,
        mirrorTranslateX: 500
      },
      socialGuide: { x: 189.99943, y: 151.74701, width: 120.00002, height: 21.99992 },
      actionGuide: { x: 231, y: 142.07851, width: 38, height: 8.5, paddingX: 1.76, paddingY: 0.71 },
      qrBox: { centerX: 331.98718, centerY: 157.11817, size: 31.7641 },
      iconCenter: { x: 167.882275, y: 157.11913 },
      textHeightMm: 22,
      iconMaximumMm: 27.7641,
      allowNoIcon: false
    }
  };
  const FONTS = [
    { id: 'arial-black', name: 'Arial Black', file: 'Arial-Black.otf' },
    { id: 'signpainter-house-script', name: 'SignPainter', file: 'SignPainter-HouseScript.otf' },
    { id: 'cocktail-shaker', name: 'Cocktail Shaker', file: 'CocktailShaker.otf' },
    { id: 'ethnocentric-regular', name: 'Ethnocentric', file: 'EthnocentricRg-Regular.otf' },
    { id: 'orbitron-bold', name: 'Orbitron Bold', file: 'Orbitron-Bold.otf' }
  ];
  const ICONS = [
    ['none', 'No icon'], ['instagram', 'Instagram'], ['youtube', 'YouTube'],
    ['tiktok', 'TikTok'], ['onlyfans', 'OnlyFans'], ['snapchat', 'Snapchat'],
    ['facebook', 'Facebook'], ['x', 'X'], ['twitch', 'Twitch'],
    ['whatsapp', 'WhatsApp'], ['discord', 'Discord'], ['reddit', 'Reddit'],
    ['fansly', 'Fansly'], ['kick', 'Kick'], ['threads', 'Threads'],
    ['pinterest', 'Pinterest'], ['linkedin', 'LinkedIn'], ['messenger', 'Messenger'],
    ['patreon', 'Patreon'], ['kofi', 'Ko-fi'], ['buymeacoffee', 'Buy Me a Coffee'],
    ['soundcloud', 'SoundCloud'], ['bandcamp', 'Bandcamp'], ['spotify', 'Spotify'],
    ['nextdoor', 'Nextdoor']
  ].map(([id, name]) => ({ id, name, file: id === 'none' ? '' : `social-icon-${id}.svg` }));

  const assetBase = (() => {
    const script = [...document.scripts].find((item) => /Gen3-configurator\.js(?:\?|$)/.test(item.src));
    return script ? new URL('.', script.src) : new URL('../Shopify%20Files/assets/', location.href);
  })();
  const assetUrl = (file) => new URL(file, assetBase).href;
  const fontsById = new Map(FONTS.map((font) => [font.id, font]));
  const iconsById = new Map(ICONS.map((icon) => [icon.id, icon]));
  const fontCache = new Map();
  const iconCache = new Map();
  const baseCache = new Map();

  function fetchSvg(file) {
    return fetch(assetUrl(file)).then((response) => {
      if (!response.ok) throw new Error(`Could not load ${file} (${response.status}).`);
      return response.text();
    }).then((text) => new DOMParser().parseFromString(text, 'image/svg+xml'));
  }

  function getBase(product) {
    if (!baseCache.has(product.base)) {
      baseCache.set(product.base, fetchSvg(product.base).catch((error) => {
        baseCache.delete(product.base);
        throw error;
      }));
    }
    return baseCache.get(product.base);
  }

  function getFont(fontId) {
    if (!fontCache.has(fontId)) {
      const font = fontsById.get(fontId);
      fontCache.set(fontId, fetch(assetUrl(font.file))
        .then((response) => {
          if (!response.ok) throw new Error(`Could not load ${font.name} (${response.status}).`);
          return response.arrayBuffer();
        })
        .then((buffer) => {
          if (!window.opentype) throw new Error('The Gen3 font path library did not load.');
          return window.opentype.parse(buffer);
        })
        .catch((error) => {
          fontCache.delete(fontId);
          throw error;
        }));
    }
    return fontCache.get(fontId);
  }

  function getIcon(iconId) {
    if (!iconCache.has(iconId)) {
      const icon = iconsById.get(iconId);
      iconCache.set(iconId, fetchSvg(icon.file).catch((error) => {
        iconCache.delete(iconId);
        throw error;
      }));
    }
    return iconCache.get(iconId);
  }

  function closeContours(path) {
    const commands = [];
    let open = false;
    for (const command of path.commands) {
      if (command.type === 'M' && open) commands.push({ type: 'Z' });
      if (command.type === 'M') open = true;
      if (command.type === 'Z') open = false;
      commands.push(command);
    }
    if (open) commands.push({ type: 'Z' });
    path.commands = commands;
    return path;
  }

  function pathData(path) {
    const number = (value) => {
      if (!Number.isFinite(value)) throw new Error('The selected font produced an invalid path coordinate.');
      return Number(value.toFixed(4)).toString();
    };
    return path.commands.map((command) => {
      if (command.type === 'M' || command.type === 'L') return `${command.type}${number(command.x)} ${number(command.y)}`;
      if (command.type === 'C') return `C${number(command.x1)} ${number(command.y1)} ${number(command.x2)} ${number(command.y2)} ${number(command.x)} ${number(command.y)}`;
      if (command.type === 'Q') return `Q${number(command.x1)} ${number(command.y1)} ${number(command.x)} ${number(command.y)}`;
      if (command.type === 'Z') return 'Z';
      throw new Error(`Unsupported font path command: ${command.type}`);
    }).join('');
  }

  function svgElement(name, attributes = {}) {
    const element = document.createElementNS(SVG_NS, name);
    for (const [key, value] of Object.entries(attributes)) element.setAttribute(key, value);
    return element;
  }

  let paperScope;

  function createTextOutline(font, text) {
    if (!window.paper?.PaperScope) throw new Error('The Gen3 path-union library did not load.');
    if (!paperScope) {
      paperScope = new window.paper.PaperScope();
      paperScope.setup(document.createElement('canvas'));
    }

    const glyphPaths = font.getPaths(text, 0, 0, 100, { kerning: true });
    let merged = null;
    try {
      for (const glyphPath of glyphPaths) {
        closeContours(glyphPath);
        const data = pathData(glyphPath);
        if (!data) continue;
        const glyph = new paperScope.CompoundPath(data);
        glyph.fillRule = 'nonzero';
        if (!merged) {
          merged = glyph;
        } else {
          const union = merged.unite(glyph, { insert: false });
          merged = union;
        }
      }

      if (!merged || !merged.closed) throw new Error('The selected font did not produce closed text outlines.');
      const bounds = merged.bounds;
      const outline = {
        d: merged.pathData,
        bounds: { x1: bounds.left, y1: bounds.top, x2: bounds.right, y2: bounds.bottom }
      };
      if (!outline.d || ![outline.bounds.x1, outline.bounds.y1, outline.bounds.x2, outline.bounds.y2].every(Number.isFinite)) {
        throw new Error('The selected font produced an invalid merged outline.');
      }
      return outline;
    } finally {
      paperScope.project.activeLayer.removeChildren();
    }
  }

  function svgViewBox(svg) {
    const values = (svg.documentElement.getAttribute('viewBox') || '').trim().split(/[ ,]+/).map(Number);
    if (values.length !== 4 || values.some((value) => !Number.isFinite(value)) || values[2] <= 0 || values[3] <= 0) {
      throw new Error('The selected social icon has an invalid SVG viewBox.');
    }
    return values;
  }

  function readBaseParts(baseDocument) {
    const source = baseDocument.documentElement;
    const cut = source.querySelector('#cut-line');
    const red = source.querySelector('#red-circle');
    const etch = source.querySelector('#etch');
    if (!cut || !red || !etch) throw new Error('The Social Tap Sign base SVG is incomplete.');
    return { source, cut, red, etch };
  }

  function readNameSignParts(baseDocument) {
    const source = baseDocument.documentElement;
    const cut = source.querySelector('#cut_lines');
    const border = source.querySelector('#boarder');
    if (!cut || !border) throw new Error('The Name Sign base SVG is incomplete.');
    return { source, cut, border };
  }

  function readMiniSocialSignParts(baseDocument) {
    const source = baseDocument.documentElement;
    const cut = source.querySelector('#cut-line');
    const red = source.querySelector('#red-circle');
    const fixedEtch = source.querySelector('#mini-fixed-etch');
    if (!cut || !fixedEtch) throw new Error('The Mini Social product base SVG is incomplete.');
    return { source, cut, red, fixedEtch };
  }

  function fitOutline(outline, widthMm, heightMm) {
    if (!outline) return null;
    const width = outline.bounds.x2 - outline.bounds.x1;
    const height = outline.bounds.y2 - outline.bounds.y1;
    if (width <= 0 || height <= 0) return null;
    const scaleMm = Math.min(widthMm / width, heightMm / height);
    return { width: width * scaleMm, height: height * scaleMm, scaleMm };
  }

  function collapsedNameAreaBottom(product) {
    return product.socialGuide.y + product.socialGuide.height - product.collapseBottomInsetMm * PX_PER_MM;
  }

  function appendOutline(group, outline, bounds, fitted, x, y) {
    if (!fitted) return;
    group.append(svgElement('path', {
      d: outline.d,
      fill: group.getAttribute('fill') || 'currentColor',
      'fill-rule': 'nonzero',
      transform: `translate(${x} ${y}) scale(${fitted.scaleMm * PX_PER_MM}) translate(${-bounds.x1} ${-bounds.y1})`
    }));
  }

  function expandNameSignBorder(border, product, expand) {
    const copy = border.cloneNode(true);
    copy.removeAttribute('class');
    copy.removeAttribute('style');
    copy.removeAttribute('stroke');
    copy.removeAttribute('stroke-width');
    copy.setAttribute('id', 'name-sign-border');
    if (!expand) return copy;

    const targetBottom = collapsedNameAreaBottom(product);
    const delta = targetBottom - product.borderOuterBottom;
    const oldCorner = product.borderLowerCornerStart;
    const oldCornerPattern = String(oldCorner).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const expression = new RegExp(`(\\bV\\s*)${oldCornerPattern}(?=\\s|$)`, 'g');
    let replacements = 0;
    const data = copy.getAttribute('d').replace(expression, (match, prefix) => {
      replacements += 1;
      return `${prefix}${oldCorner + delta}`;
    });
    if (replacements !== 2) throw new Error('The Name Sign border could not be expanded to the social guide.');
    copy.setAttribute('d', data);
    return copy;
  }

  function createNameSignArtwork(product, parts, values, outlines, fonts, iconDocument, iconId, mirror, colors) {
    const svg = svgElement('svg', {
      xmlns: SVG_NS,
      version: '1.1',
      width: `${product.page.widthMm}mm`,
      height: `${product.page.heightMm}mm`,
      viewBox: `0 0 ${product.page.width} ${product.page.height}`,
      preserveAspectRatio: 'xMidYMid meet'
    });
    const title = svgElement('title');
    title.textContent = `${product.name} — ${values.name.trim() || 'No name'} — ${values.handle.trim() || 'No handle'} — ${fontsById.get(fonts.name).name} — ${fontsById.get(fonts.social).name} — ${iconsById.get(iconId).name} — ${VERSION}`;
    svg.append(title);

    const cut = parts.cut.cloneNode(true);
    cut.removeAttribute('class');
    cut.removeAttribute('style');
    cut.removeAttribute('clip-path');
    cut.removeAttribute('stroke');
    cut.removeAttribute('stroke-width');
    cut.setAttribute('id', 'cut-line');
    cut.setAttribute('fill', colors.cut);
    cut.setAttribute('fill-rule', 'evenodd');

    const collapseSocial = iconId === 'none' && !values.handle.trim();
    const border = expandNameSignBorder(parts.border, product, collapseSocial);
    border.setAttribute('fill', colors.etch);
    const etch = svgElement('g', { id: 'etch', fill: colors.etch });
    etch.append(border);

    const nameGuide = product.nameGuide;
    const nameHeight = collapseSocial
      ? collapsedNameAreaBottom(product) - nameGuide.y
      : nameGuide.height;
    const nameFit = fitOutline(outlines.name, nameGuide.width / PX_PER_MM, nameHeight / PX_PER_MM);
    if (nameFit) {
      const x = nameGuide.x + (nameGuide.width - nameFit.width * PX_PER_MM) / 2;
      const y = nameGuide.y + (nameHeight - nameFit.height * PX_PER_MM) / 2;
      appendOutline(etch, outlines.name, outlines.name.bounds, nameFit, x, y);
    }

    const social = product.socialGuide;
    const handleFit = fitOutline(outlines.handle, social.width / PX_PER_MM, product.textHeightMm);
    const hasIcon = iconId !== 'none';
    const gapMm = hasIcon && handleFit ? product.iconGapMm : 0;
    const [iconX0, iconY0, iconViewWidth, iconViewHeight] = hasIcon ? svgViewBox(iconDocument) : [0, 0, 1, 1];
    const iconScale = hasIcon ? (product.iconMaximumMm * PX_PER_MM / Math.max(iconViewWidth, iconViewHeight)) : 0;
    const iconWidth = hasIcon ? iconViewWidth * iconScale : 0;
    const iconHeight = hasIcon ? iconViewHeight * iconScale : 0;

    let fittedHandle = handleFit;
    if (handleFit) {
      const maxWidthMm = social.width / PX_PER_MM - iconWidth / PX_PER_MM - gapMm;
      fittedHandle = fitOutline(outlines.handle, maxWidthMm, product.textHeightMm);
    }
    const handleWidth = fittedHandle ? fittedHandle.width * PX_PER_MM : 0;
    const handleHeight = fittedHandle ? fittedHandle.height * PX_PER_MM : 0;
    const gap = fittedHandle && hasIcon ? gapMm * PX_PER_MM : 0;
    const totalWidth = handleWidth + gap + iconWidth;
    const startX = social.x + (social.width - totalWidth) / 2;

    if (fittedHandle) {
      const x = startX + (hasIcon ? iconWidth + gap : 0);
      const y = social.y + (social.height - handleHeight) / 2;
      appendOutline(etch, outlines.handle, outlines.handle.bounds, fittedHandle, x, y);
    }

    if (hasIcon) {
      const iconX = startX;
      const iconY = social.y + (social.height - iconHeight) / 2;
      const iconGroup = svgElement('g', {
        transform: `translate(${iconX} ${iconY}) scale(${iconScale}) translate(${-iconX0} ${-iconY0})`
      });
      for (const child of [...iconDocument.documentElement.children]) {
        if (child.localName === 'title' || child.localName === 'desc') continue;
        const copied = document.importNode(child, true);
        for (const element of [copied, ...copied.querySelectorAll('*')]) {
          element.removeAttribute('id');
          if (/^(path|polygon|rect|circle|ellipse)$/i.test(element.localName)) {
            element.setAttribute('fill', colors.etch);
            element.removeAttribute('stroke');
          }
        }
        iconGroup.append(copied);
      }
      etch.append(iconGroup);
    }

    if (mirror) {
      const mirrorTransform = `translate(${product.page.width} 0) scale(-1 1)`;
      cut.setAttribute('transform', mirrorTransform);
      etch.setAttribute('transform', mirrorTransform);
    }
    svg.append(cut, etch);
    return svg;
  }

  function explicitlyCloseSvgPathData(data) {
    let result = '';
    let cursor = 0;
    let open = false;
    for (const match of data.matchAll(/[MmZz]/g)) {
      const command = match[0];
      if ((command === 'M' || command === 'm') && open) {
        result += `${data.slice(cursor, match.index)}z `;
        cursor = match.index;
        open = false;
      }
      if (command === 'M' || command === 'm') open = true;
      else open = false;
    }
    result += data.slice(cursor);
    return `${result.trim()}${open ? ' z' : ''}`;
  }

  function createMiniSocialSignArtwork(product, parts, values, socialFontId, outline, iconDocument, iconId, mirror, colors, actionOutline, qrPath) {
    const page = product.page;
    const svg = svgElement('svg', {
      xmlns: SVG_NS,
      version: '1.1',
      width: `${page.widthMm}mm`,
      height: `${page.heightMm}mm`,
      viewBox: `${page.x} ${page.y} ${page.width} ${page.height}`,
      preserveAspectRatio: 'xMidYMid meet'
    });
    const title = svgElement('title');
    title.textContent = `${product.name} — ${values.handle.trim() || 'No handle'} — ${fontsById.get(socialFontId).name} — ${iconsById.get(iconId).name} — ${VERSION}`;
    svg.append(title);

    const cut = parts.cut.cloneNode(true);
    cut.setAttribute('id', 'cut-line');
    cut.setAttribute('fill', colors.cut);
    cut.setAttribute('fill-rule', 'nonzero');
    cut.removeAttribute('style');

    const red = parts.red?.cloneNode(true);
    if (red) {
      red.setAttribute('id', 'red-circle');
      red.setAttribute('fill', colors.deepEtch);
      red.setAttribute('fill-rule', 'nonzero');
      red.removeAttribute('style');
    } else if (product.action === 'tap') {
      throw new Error('The Mini Social Tap Sign base SVG is missing its NFC chip circle.');
    }

    const etch = parts.fixedEtch.cloneNode(true);
    etch.setAttribute('id', 'etch');
    etch.setAttribute('fill', colors.etch);
    etch.removeAttribute('style');
    for (const path of etch.querySelectorAll('path')) {
      path.setAttribute('fill', colors.etch);
      path.setAttribute('fill-rule', 'nonzero');
      path.removeAttribute('style');
    }

    if (product.action === 'scan') {
      const action = product.actionGuide;
      const fittedAction = fitOutline(actionOutline, action.width - action.paddingX * 2, action.height - action.paddingY * 2);
      if (!fittedAction || !qrPath) throw new Error('The QR artwork could not be prepared.');
      const actionX = action.x + (action.width - fittedAction.width) / 2;
      const actionY = action.y + (action.height - fittedAction.height) / 2;
      etch.append(
        svgElement('path', {
          id: 'scan-here-label',
          d: actionOutline.d,
          fill: colors.etch,
          'fill-rule': 'nonzero',
          transform: `translate(${actionX} ${actionY}) scale(${fittedAction.scaleMm}) translate(${-actionOutline.bounds.x1} ${-actionOutline.bounds.y1})`
        }),
        svgElement('path', {
          id: 'qr-code',
          d: qrPath,
          fill: colors.etch,
          'fill-rule': 'evenodd',
          'shape-rendering': 'crispEdges'
        })
      );
    }

    const guide = product.socialGuide;
    const fitted = outline
      ? fitOutline(outline, guide.width, Math.min(product.textHeightMm, guide.height))
      : null;
    if (fitted) {
      const x = guide.x + (guide.width - fitted.width) / 2;
      const y = guide.y + (guide.height - fitted.height) / 2;
      etch.append(svgElement('path', {
        d: outline.d,
        fill: colors.etch,
        'fill-rule': 'nonzero',
        transform: `translate(${x} ${y}) scale(${fitted.scaleMm}) translate(${-outline.bounds.x1} ${-outline.bounds.y1})`
      }));
    }

    if (iconId !== 'none') {
      const [viewX, viewY, viewWidth, viewHeight] = svgViewBox(iconDocument);
      const iconScale = product.iconMaximumMm / Math.max(viewWidth, viewHeight);
      const iconWidth = viewWidth * iconScale;
      const iconHeight = viewHeight * iconScale;
      const left = product.iconCenter.x - iconWidth / 2;
      const top = product.iconCenter.y - iconHeight / 2;
      const iconGroup = svgElement('g', {
        transform: `translate(${left} ${top}) scale(${iconScale}) translate(${-viewX} ${-viewY})`
      });
      for (const child of [...iconDocument.documentElement.children]) {
        if (child.localName === 'title' || child.localName === 'desc') continue;
        const copied = document.importNode(child, true);
        for (const element of [copied, ...copied.querySelectorAll('*')]) {
          element.removeAttribute('id');
          if (/^(path|polygon|rect|circle|ellipse)$/i.test(element.localName)) {
            element.setAttribute('fill', colors.etch);
            element.removeAttribute('stroke');
            if (element.localName === 'path' && element.hasAttribute('d')) {
              element.setAttribute('d', explicitlyCloseSvgPathData(element.getAttribute('d')));
            }
          }
        }
        iconGroup.append(copied);
      }
      etch.append(iconGroup);
    }

    if (mirror) {
      const mirrorTransform = `translate(${page.mirrorTranslateX} 0) scale(-1 1)`;
      cut.setAttribute('transform', mirrorTransform);
      if (red) red.setAttribute('transform', mirrorTransform);
      etch.setAttribute('transform', mirrorTransform);
    }
    svg.append(cut);
    if (red) svg.append(red);
    svg.append(etch);
    return svg;
  }

  function createArtwork(product, parts, textValue, fontId, textOutline, iconDocument, iconId, mirror, colors) {
    const svg = svgElement('svg', {
      xmlns: SVG_NS,
      version: '1.1',
      width: `${product.page.widthMm}mm`,
      height: `${product.page.heightMm}mm`,
      viewBox: `0 0 ${product.page.width} ${product.page.height}`,
      preserveAspectRatio: 'xMidYMid meet'
    });
    const title = svgElement('title');
    const iconName = iconsById.get(iconId).name;
    title.textContent = `${product.name} — ${textValue.trim() || 'No text'} — ${fontsById.get(fontId).name} — ${iconName} — ${VERSION}`;
    svg.append(title);

    const cut = parts.cut.cloneNode(true);
    const red = parts.red.cloneNode(true);
    const etch = parts.etch.cloneNode(true);
    cut.setAttribute('fill', colors.cut);
    red.setAttribute('fill', colors.deepEtch);
    etch.setAttribute('fill', colors.etch);
    if (mirror) {
      const mirrorTransform = `translate(${product.page.width} 0) scale(-1 1)`;
      cut.setAttribute('transform', `${mirrorTransform} ${cut.getAttribute('transform') || ''}`.trim());
      red.setAttribute('transform', `${mirrorTransform} ${red.getAttribute('transform') || ''}`.trim());
      etch.setAttribute('transform', mirrorTransform);
    }
    cut.removeAttribute('clip-path');

    const guide = product.guide;
    const px = PX_PER_MM;
    const guideWidthMm = guide.width / px;
    const gapMm = iconId !== 'none' && textValue.trim() ? product.iconGapMm : 0;
    const textBounds = textOutline?.bounds || null;
    let textScale = 0;
    let nominalWidth = 0;
    let nominalHeight = 0;

    if (textOutline) {
      nominalWidth = textBounds.x2 - textBounds.x1;
      nominalHeight = textBounds.y2 - textBounds.y1;
      if (nominalWidth > 0 && nominalHeight > 0) {
        const iconWidthMm = iconId === 'none' ? 0 : (() => {
          const [, , width, height] = svgViewBox(iconDocument);
          return product.iconMaximumMm * width / Math.max(width, height);
        })();
        const maxTextWidthMm = Math.max(0, guideWidthMm - iconWidthMm - gapMm);
        textScale = Math.min(product.textHeightMm / nominalHeight, maxTextWidthMm / nominalWidth);
      }
    }

    const hasText = Boolean(textOutline && textScale > 0);
    const [, , iconViewWidth, iconViewHeight] = iconId === 'none' ? [0, 0, 1, 1] : svgViewBox(iconDocument);
    const iconScale = iconId === 'none' ? 0 : (product.iconMaximumMm * px / Math.max(iconViewWidth, iconViewHeight));
    const iconWidth = iconViewWidth * iconScale;
    const iconHeight = iconViewHeight * iconScale;
    const textWidth = hasText ? nominalWidth * textScale * px : 0;
    const textHeight = hasText ? nominalHeight * textScale * px : 0;
    const gap = hasText && iconId !== 'none' ? gapMm * px : 0;
    const totalWidth = textWidth + gap + (iconId === 'none' ? 0 : iconWidth);
    const startX = guide.x + (guide.width - totalWidth) / 2;
    const textX = startX + (iconId === 'none' ? 0 : iconWidth + gap);

    if (hasText) {
      const scaleToPage = textScale * px;
      const y = guide.y + (guide.height - textHeight) / 2;
      const x = textX;
      etch.append(svgElement('path', {
        d: textOutline.d,
        fill: colors.etch,
        'fill-rule': 'nonzero',
        transform: `translate(${x} ${y}) scale(${scaleToPage}) translate(${-textBounds.x1} ${-textBounds.y1})`
      }));
    }

    if (iconId !== 'none') {
      const iconX = startX;
      const iconY = guide.y + (guide.height - iconHeight) / 2;
      const [iconX0, iconY0] = svgViewBox(iconDocument);
      const iconGroup = svgElement('g', {
        transform: `translate(${iconX} ${iconY}) scale(${iconScale}) translate(${-iconX0} ${-iconY0})`
      });
      for (const child of [...iconDocument.documentElement.children]) {
        if (child.localName === 'title' || child.localName === 'desc') continue;
        const copied = document.importNode(child, true);
        for (const element of [copied, ...copied.querySelectorAll('*')]) {
          element.removeAttribute('id');
          if (element.localName === 'path' || element.localName === 'polygon' || element.localName === 'circle' || element.localName === 'rect') {
            element.setAttribute('fill', colors.etch);
            element.removeAttribute('stroke');
          }
        }
        iconGroup.append(copied);
      }
      etch.append(iconGroup);
    }

    svg.append(cut, red, etch);
    return svg;
  }

  function stylePreview(svg, instanceId, root) {
    const settings = getComputedStyle(root);
    const rainbowId = `gen3-preview-rainbow-${instanceId}`;
    const glowId = `gen3-preview-cut-glow-${instanceId}`;
    const etchGlowId = `gen3-preview-etch-glow-${instanceId}`;
    const maskId = `gen3-preview-etch-mask-${instanceId}`;
    const spread = Number.parseFloat(settings.getPropertyValue('--gen3-preview-rainbow-spread')) || 1.25;
    const cycle = settings.getPropertyValue('--gen3-preview-rainbow-cycle').trim() || '30s';
    const artwork = [svg.querySelector('#red-circle'), svg.querySelector('#etch')].filter(Boolean);
    const viewBox = svg.viewBox.baseVal;
    let artworkLeft = viewBox.x;
    let artworkWidth = viewBox.width;
    try {
      const bounds = artwork.map((group) => group.getBBox());
      const left = Math.min(...bounds.map((box) => box.x));
      const right = Math.max(...bounds.map((box) => box.x + box.width));
      if (Number.isFinite(left) && right > left) {
        artworkLeft = left;
        artworkWidth = right - left;
      }
    } catch {
      // Use the viewBox width if the browser cannot measure SVG bounds.
    }
    const rainbowWidth = Math.max(1, artworkWidth * spread);
    const gradient = svgElement('linearGradient', {
      id: rainbowId,
      gradientUnits: 'userSpaceOnUse',
      x1: String(artworkLeft),
      y1: '0',
      x2: String(artworkLeft + rainbowWidth),
      y2: '0',
      spreadMethod: 'repeat'
    });
    const rainbow = [
      '--gen3-preview-rainbow-red', '--gen3-preview-rainbow-orange',
      '--gen3-preview-rainbow-yellow', '--gen3-preview-rainbow-lime',
      '--gen3-preview-rainbow-green', '--gen3-preview-rainbow-cyan',
      '--gen3-preview-rainbow-blue', '--gen3-preview-rainbow-violet',
      '--gen3-preview-rainbow-red'
    ];
    rainbow.forEach((name, index) => {
      gradient.append(svgElement('stop', {
        offset: `${index * 12.5}%`,
        'stop-color': settings.getPropertyValue(name).trim()
      }));
    });

    const filter = svgElement('filter', {
      id: glowId, x: '-20%', y: '-20%', width: '140%', height: '140%',
      'color-interpolation-filters': 'sRGB'
    });
    filter.append(svgElement('feDropShadow', {
      dx: '0',
      dy: '0',
      stdDeviation: settings.getPropertyValue('--gen3-preview-cut-glow-blur').trim() || '5',
      'flood-color': settings.getPropertyValue('--gen3-preview-cut-glow').trim() || '#000000',
      'flood-opacity': settings.getPropertyValue('--gen3-preview-cut-glow-opacity').trim() || '0.65'
    }));

    const etchGlowFilter = svgElement('filter', {
      id: etchGlowId, x: '-20%', y: '-20%', width: '140%', height: '140%',
      'color-interpolation-filters': 'sRGB'
    });
    etchGlowFilter.append(svgElement('feDropShadow', {
      dx: '0',
      dy: '0',
      stdDeviation: settings.getPropertyValue('--gen3-preview-etch-glow-blur').trim() || '1.2',
      'flood-color': settings.getPropertyValue('--gen3-preview-cut-glow').trim() || '#000000',
      'flood-opacity': '1'
    }));

    const mask = svgElement('mask', {
      id: maskId,
      maskUnits: 'userSpaceOnUse',
      maskContentUnits: 'userSpaceOnUse',
      x: String(viewBox.x),
      y: String(viewBox.y),
      width: String(viewBox.width),
      height: String(viewBox.height),
      'mask-type': 'alpha'
    });
    for (const group of artwork) {
      const copy = group.cloneNode(true);
      for (const element of [copy, ...copy.querySelectorAll('*')]) {
        element.removeAttribute('id');
        element.removeAttribute('style');
        if (/^(path|polygon|rect|circle|ellipse)$/i.test(element.localName)) {
          element.setAttribute('fill', '#ffffff');
          element.setAttribute('fill-opacity', '1');
          element.setAttribute('stroke', 'none');
        }
      }
      mask.append(copy);
    }

    const etchGlow = svgElement('g', {
      filter: `url(#${etchGlowId})`,
      opacity: settings.getPropertyValue('--gen3-preview-etch-glow-opacity').trim() || '0.75',
      'aria-hidden': 'true'
    });
    for (const group of artwork) {
      const copy = group.cloneNode(true);
      for (const element of [copy, ...copy.querySelectorAll('*')]) {
        element.removeAttribute('id');
        element.removeAttribute('style');
        if (/^(path|polygon|rect|circle|ellipse)$/i.test(element.localName)) {
          element.setAttribute('fill', '#000000');
          element.setAttribute('fill-opacity', '1');
          element.setAttribute('stroke', 'none');
        }
      }
      etchGlow.append(copy);
    }

    const defs = svgElement('defs');
    defs.append(gradient, filter, etchGlowFilter, mask);
    const title = svg.querySelector('title');
    if (title) title.after(defs);
    else svg.prepend(defs);

    const cut = svg.querySelector('#cut-line');
    cut.setAttribute('fill', settings.getPropertyValue('--gen3-preview-cut-fill').trim() || '#ffffff');
    cut.setAttribute('filter', `url(#${glowId})`);

    artwork.forEach((group) => group.remove());
    svg.append(etchGlow);
    svg.append(svgElement('rect', {
      x: String(viewBox.x),
      y: String(viewBox.y),
      width: String(viewBox.width),
      height: String(viewBox.height),
      fill: `url(#${rainbowId})`,
      mask: `url(#${maskId})`,
      'pointer-events': 'none'
    }));

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const cycleValue = Number.parseFloat(cycle);
      const cycleMilliseconds = cycleValue * (cycle.trim().endsWith('ms') ? 1 : 1000);
      if (Number.isFinite(cycleMilliseconds) && cycleMilliseconds > 0) {
        const startedAt = performance.now();
        const animateRainbow = (now) => {
          if (!svg.isConnected) return;
          const progress = ((now - startedAt) % cycleMilliseconds) / cycleMilliseconds;
          const offset = rainbowWidth * progress;
          gradient.setAttribute('x1', String(artworkLeft - offset));
          gradient.setAttribute('x2', String(artworkLeft + rainbowWidth - offset));
          requestAnimationFrame(animateRainbow);
        };
        requestAnimationFrame(animateRainbow);
      }
    }
  }

  function serialise(svg) {
    return `<?xml version="1.0" encoding="UTF-8"?>\n${new XMLSerializer().serializeToString(svg)}\n`;
  }

  function textFileName(value, fallback) {
    const stem = value.trim()
      .replace(/[<>:"\\|?*\u0000-\u001f\u007f]/g, '-')
      .replace(/\//g, '-')
      .replace(/\s+/g, ' ')
      .replace(/-+/g, '-')
      .replace(/[. ]+$/, '');
    return `${stem || fallback}.svg`;
  }

  let configuratorId = 0;

  function setOptions(root, field, options, selected, instanceId) {
    const groups = [...root.querySelectorAll(`[data-options="${field}"]`)];
    groups.forEach((group, groupIndex) => {
      group.replaceChildren();
      const productId = group.closest('[data-product-controls]')?.dataset.productControls || root.dataset.gen3Product;
      const groupOptions = field === 'icon' && PRODUCTS[productId]?.allowNoIcon === false
        ? options.filter((option) => option.id !== 'none')
        : options;
      for (const option of groupOptions) {
        const label = document.createElement('label');
        label.className = 'gen3-configurator__option';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = `gen3-${instanceId}-${field}-${groupIndex}`;
        input.value = option.id;
        input.dataset.field = field;
        input.required = true;
        input.setAttribute('aria-label', option.name);
        input.checked = option.id === selected;
        const caption = document.createElement('span');
        caption.className = 'gen3-configurator__option-label';
        if (field === 'icon') {
          caption.dataset.gen3Icon = option.id;
          if (option.file) {
            const image = document.createElement('img');
            image.src = assetUrl(option.file);
            image.alt = '';
            image.setAttribute('aria-hidden', 'true');
            caption.append(image);
          } else {
            const mark = svgElement('svg', {
              viewBox: '0 0 24 24',
              'aria-hidden': 'true',
              focusable: 'false'
            });
            mark.append(
              svgElement('circle', {
                cx: '12', cy: '12', r: '9.25', fill: 'none',
                stroke: 'currentColor', 'stroke-width': '1.8'
              }),
              svgElement('path', {
                d: 'm5.5 18.5 13-13', fill: 'none', stroke: 'currentColor',
                'stroke-width': '1.8', 'stroke-linecap': 'round'
              })
            );
            caption.append(mark);
          }
        } else {
          caption.textContent = option.name;
        }
        if (field === 'font' || field === 'name-font' || field === 'social-font') {
          caption.dataset.gen3Font = option.id;
        }
        label.append(input, caption);
        group.append(label);
      }
    });
  }

  function selectedOption(root, field) {
    return root.querySelector(`[data-field="${field}"]:checked`)?.value || '';
  }

  function controlsFor(root, productId) {
    return [...root.querySelectorAll('[data-product-controls]')]
      .find((group) => group.dataset.productControls === productId) || root;
  }

  function primaryTextField(product, controls) {
    const field = product.builder === 'name-sign'
      ? 'name'
      : product.builder === 'mini-social'
        ? 'social-handle'
        : 'text';
    return controls.querySelector(`[data-field="${field}"]`);
  }

  function init(root) {
    if (root.dataset.gen3Initialized === 'true') return;
    const productGroup = root.querySelector('[data-options="product"]');
    const button = root.querySelector('[data-action]');
    const preview = root.querySelector('[data-role="preview"]');
    const status = root.querySelector('[data-role="status"]');
    const form = root.querySelector('form');
    const versionProperty = root.querySelector('[data-property="version"]');
    const svgProperty = root.querySelector('[data-property="svg"]');
    if (!button || !preview || !status) return;
    root.dataset.gen3Initialized = 'true';

    const instanceId = ++configuratorId;
    const productOptions = Object.entries(PRODUCTS).map(([id, product]) => ({ id, name: product.name }));
    setOptions(root, 'product', productOptions, root.dataset.gen3Product || productOptions[0]?.id, instanceId);
    setOptions(root, 'font', FONTS, FONTS[0].id, instanceId);
    setOptions(root, 'name-font', FONTS, FONTS[0].id, instanceId);
    setOptions(root, 'social-font', FONTS, FONTS[0].id, instanceId);
    setOptions(root, 'icon', ICONS, 'instagram', instanceId);
    if (versionProperty) versionProperty.value = VERSION;

    let sequence = 0;
    let ready = false;
    let exportSvg = '';
    let activeProductId = '';
    const setStatus = (message) => {
      status.textContent = message;
      status.hidden = !message;
    };

    const updateProductControls = () => {
      activeProductId = selectedOption(root, 'product') || root.dataset.gen3Product || Object.keys(PRODUCTS)[0];
      for (const group of root.querySelectorAll('[data-product-controls]')) {
        group.hidden = group.dataset.productControls !== activeProductId;
      }
      return activeProductId;
    };

    const syncProperties = (product, controls) => {
      const setProperty = (field, value) => {
        const input = root.querySelector(`[data-property="${field}"]`);
        if (input) input.value = value;
      };
      const iconId = selectedOption(controls, 'icon') || 'none';
      setProperty('icon', iconsById.get(iconId).name);
      if (product.builder === 'social-tap-sign') {
        setProperty('font', fontsById.get(selectedOption(controls, 'font')).name);
      } else if (product.builder === 'mini-social') {
        setProperty('social-font', fontsById.get(selectedOption(controls, 'social-font')).name);
        if (product.action === 'scan') {
          const link = window.Gen3QRCode?.normalizeUrl(controls.querySelector('[data-field="social-link"]')?.value);
          setProperty('social-link', link?.normalized || '');
        }
      } else {
        setProperty('name-font', fontsById.get(selectedOption(controls, 'name-font')).name);
        setProperty('social-font', fontsById.get(selectedOption(controls, 'social-font')).name);
      }
    };

    const colors = {
      cut: getComputedStyle(root).getPropertyValue('--gen3-color-cut').trim() || '#000000',
      etch: getComputedStyle(root).getPropertyValue('--gen3-color-etch').trim() || '#00ffff',
      deepEtch: getComputedStyle(root).getPropertyValue('--gen3-color-deep-etch').trim() || '#ff0000'
    };

    const render = async () => {
      const current = ++sequence;
      ready = false;
      button.disabled = true;
      setStatus('');
      try {
        const productId = updateProductControls();
        const product = PRODUCTS[productId];
        if (!product) throw new Error('Select a supported product.');
        const controls = controlsFor(root, productId);
        syncProperties(product, controls);
        const iconId = selectedOption(controls, 'icon') || 'none';
        let previewSvg;
        let productionSvg;

        if (product.builder === 'social-tap-sign') {
          const textField = controls.querySelector('[data-field="text"]');
          const fontId = selectedOption(controls, 'font');
          const [base, font, iconDocument] = await Promise.all([
            getBase(product),
            getFont(fontId),
            iconId === 'none' ? Promise.resolve(null) : getIcon(iconId)
          ]);
          if (current !== sequence) return;
          const parts = readBaseParts(base);
          const textOutline = textField.value.trim() ? createTextOutline(font, textField.value) : null;
          previewSvg = createArtwork(product, parts, textField.value, fontId, textOutline, iconDocument, iconId, false, colors);
          productionSvg = createArtwork(product, parts, textField.value, fontId, textOutline, iconDocument, iconId, true, colors);
        } else if (product.builder === 'name-sign') {
          const nameField = controls.querySelector('[data-field="name"]');
          const handleField = controls.querySelector('[data-field="social-handle"]');
          const nameFont = selectedOption(controls, 'name-font');
          const socialFont = selectedOption(controls, 'social-font');
          const [base, nameFontData, socialFontData, iconDocument] = await Promise.all([
            getBase(product),
            getFont(nameFont),
            getFont(socialFont),
            iconId === 'none' ? Promise.resolve(null) : getIcon(iconId)
          ]);
          if (current !== sequence) return;
          const parts = readNameSignParts(base);
          const values = { name: nameField.value, handle: handleField.value };
          const outlines = {
            name: values.name.trim() ? createTextOutline(nameFontData, values.name) : null,
            handle: values.handle.trim() ? createTextOutline(socialFontData, values.handle) : null
          };
          const fonts = { name: nameFont, social: socialFont };
          previewSvg = createNameSignArtwork(product, parts, values, outlines, fonts, iconDocument, iconId, false, colors);
          productionSvg = createNameSignArtwork(product, parts, values, outlines, fonts, iconDocument, iconId, true, colors);
        } else if (product.builder === 'mini-social') {
          const handleField = controls.querySelector('[data-field="social-handle"]');
          const linkField = controls.querySelector('[data-field="social-link"]');
          const socialFont = selectedOption(controls, 'social-font');
          const normalizedLink = product.action === 'scan'
            ? window.Gen3QRCode?.normalizeUrl(linkField?.value)
            : null;
          if (product.action === 'scan' && !normalizedLink) throw new Error('The Gen3 QR code library did not load.');
          if (product.action === 'scan' && root.dataset.mode === 'shopify') {
            const hasLink = Boolean(linkField?.value.trim());
            linkField?.setCustomValidity(hasLink && !normalizedLink.valid ? 'Enter a valid http or https Social Link.' : '');
          }
          const [base, socialFontData, iconDocument, actionFontData] = await Promise.all([
            getBase(product),
            getFont(socialFont),
            iconId === 'none' ? Promise.resolve(null) : getIcon(iconId),
            product.action === 'scan' ? getFont('signpainter-house-script') : Promise.resolve(null)
          ]);
          if (current !== sequence) return;
          const parts = readMiniSocialSignParts(base);
          const values = { handle: handleField.value, link: normalizedLink?.normalized || linkField?.value || '' };
          const outline = values.handle.trim() ? createTextOutline(socialFontData, values.handle) : null;
          const actionOutline = product.action === 'scan' ? createTextOutline(actionFontData, 'Scan Here') : null;
          let qrPath = null;
          if (product.action === 'scan') {
            const box = product.qrBox;
            const placeholderModules = 29;
            const quietZone = 4;
            const placeholderSize = box.size * placeholderModules / (placeholderModules + quietZone * 2);
            const left = box.centerX - placeholderSize / 2;
            const top = box.centerY - placeholderSize / 2;
            const placeholder = `M${left} ${top}h${placeholderSize}v${placeholderSize}h-${placeholderSize}z`;
            qrPath = placeholder;
            if (normalizedLink.valid) {
              try {
                qrPath = window.Gen3QRCode.pathData(values.link, box);
              } catch (error) {
                if (!error.message.includes('too long')) throw error;
                if (root.dataset.mode === 'shopify') {
                  linkField?.setCustomValidity('This Social Link is too long to fit in a QR code.');
                }
              }
            }
          }
          previewSvg = createMiniSocialSignArtwork(product, parts, values, socialFont, outline, iconDocument, iconId, false, colors, actionOutline, qrPath);
          productionSvg = createMiniSocialSignArtwork(product, parts, values, socialFont, outline, iconDocument, iconId, true, colors, actionOutline, qrPath);
        } else {
          throw new Error('The selected product does not have a vector builder.');
        }

        if (current !== sequence) return;
        preview.replaceChildren(previewSvg);
        stylePreview(previewSvg, instanceId, root);
        exportSvg = serialise(productionSvg);
        ready = true;
        button.disabled = false;
        setStatus('');
      } catch (error) {
        if (current !== sequence) return;
        console.error(error);
        setStatus(`Configurator error: ${error.message}`);
      }
    };

    for (const input of root.querySelectorAll('input[type="text"][data-field]')) {
      input.addEventListener('input', render);
    }
    for (const group of root.querySelectorAll('[data-options]')) {
      if (group !== productGroup) group.addEventListener('change', render);
    }
    productGroup?.addEventListener('change', () => {
      updateProductControls();
      render();
    });
    updateProductControls();

    if (root.dataset.mode === 'preview' || root.dataset.mode === 'owner') {
      button.addEventListener('click', () => {
        if (!ready) return;
        const product = PRODUCTS[activeProductId];
        const controls = controlsFor(root, activeProductId);
        const filenameField = primaryTextField(product, controls);
        const blob = new Blob([exportSvg], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = root.dataset.mode === 'owner'
          ? textFileName(filenameField.value, product.fileName)
          : `${product.fileName}-${VERSION.toLowerCase()}.svg`;
        document.body.append(link);
        link.click();
        setTimeout(() => {
          link.remove();
          URL.revokeObjectURL(url);
        }, 30000);
      });
    } else if (form) {
      form.addEventListener('submit', (event) => {
        const product = PRODUCTS[activeProductId];
        const controls = controlsFor(root, activeProductId);
        syncProperties(product, controls);
        if (!ready) {
          event.preventDefault();
          setStatus('Please wait for the preview to finish before adding this item.');
          return;
        }
        if (root.dataset.mode === 'shopify') {
          try {
            if (!svgProperty) throw new Error('The generated SVG upload field is missing.');
            const filenameField = primaryTextField(product, controls);
            const filename = product.builder === 'name-sign' || product.builder === 'mini-social'
              ? textFileName(filenameField.value, product.fileName)
              : `${product.fileName}-${VERSION.toLowerCase()}.svg`;
            const file = new File([exportSvg], filename, { type: 'image/svg+xml' });
            const transfer = new DataTransfer();
            transfer.items.add(file);
            svgProperty.files = transfer.files;
          } catch (error) {
            event.preventDefault();
            console.error(error);
            setStatus('This browser could not attach the generated SVG. Please try a current browser.');
          }
        }
      });
    }

    render();
  }

  document.querySelectorAll('[data-gen3-configurator]').forEach(init);
})();
